var map = {
	"./betting_icon.embedded.svg": 1243,
	"./champions_league.embedded.svg": 1244,
	"./conmebol_icon.embedded.svg": 1245,
	"./csgo_icon.embedded.svg": 1246,
	"./dfs_icon.embedded.svg": 1247,
	"./dota2_icon.embedded.svg": 1248,
	"./dr_pepper.embedded.svg": 1249,
	"./dreamhack_icon.embedded.svg": 1250,
	"./esl_icon.embedded.svg": 1251,
	"./fifa.embedded.svg": 1252,
	"./fnatic_icon.embedded.svg": 1253,
	"./fortnite.embedded.svg": 1254,
	"./i_league_icon.embedded.svg": 1255,
	"./logo-12up.embedded.svg": 532,
	"./logo-90min.embedded.svg": 533,
	"./logo-dbltap.embedded.svg": 534,
	"./logo-ei.embedded.svg": 535,
	"./logo-floor8.embedded.svg": 536,
	"./logo-ftb90.embedded.svg": 537,
	"./logo-german_site.embedded.svg": 538,
	"./logo-ht_media.embedded.svg": 539,
	"./logo-pluralist.embedded.svg": 540,
	"./logo-theduel-mobile.embedded.svg": 541,
	"./logo-theduel.embedded.svg": 542,
	"./lol_icon.embedded.svg": 1256,
	"./mdl_icon.embedded.svg": 1257,
	"./melee_icon.embedded.svg": 1258,
	"./mlb_icon.embedded.svg": 1259,
	"./mls_icon.embedded.svg": 1260,
	"./nba_icon.embedded.svg": 1261,
	"./ncaa-basketball_icon.embedded.svg": 1262,
	"./ncaa-football_icon.embedded.svg": 1263,
	"./nfl_icon.embedded.svg": 1264,
	"./overwatch_icon.embedded.svg": 1265,
	"./powered-by-ei.embedded.svg": 543,
	"./powered-by-german_site.embedded.svg": 544,
	"./powered-by-ht_media.embedded.svg": 545,
	"./pubg.embedded.svg": 1266,
	"./smash4_icon.embedded.svg": 1267,
	"./streetfighter_icon.embedded.svg": 1268,
	"./theduel-nav.embedded.svg": 1269,
	"./theduel_menu_icon.embedded.svg": 1270,
	"./world-cup.embedded.svg": 1271,
	"./yousport_icon.embedded.svg": 1272
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1284;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1284
// module chunks = 15